import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth.service';
import { HomeApiService, HomeResumo } from 'src/app/core/services/home-api.service';
import { OnboardingApiService } from 'src/app/core/services/onboarding-api.service';
import { SetupStatus } from './setup-checklist/setup-checklist.component';
import { TourService } from 'src/app/shared/tour/tour.service';
import { TourFlagService } from 'src/app/shared/tour/tour-flag.service';
import { calcularSaudacao } from 'src/app/core/utils/string.utils';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  saudacao = '';
  nomeUsuario = '';
  dataAtual = '';

  resumo: HomeResumo | null = null;
  carregando = true;

  setupStatus: SetupStatus | null = null;
  mostrarSetup = false;
  isGestor = false;

  constructor(
    private auth: AuthService,
    private homeApi: HomeApiService,
    private onboardingApi: OnboardingApiService,
    private tourService: TourService,
    private tourFlagService: TourFlagService,
    private router: Router
  ) {}

  ngOnInit(): void {
    const user = this.auth.getUser();
    this.nomeUsuario = user?.nome ?? 'Usuário';
    this.saudacao = calcularSaudacao();
    this.dataAtual = this.formatarData(new Date());
    this.isGestor = this.auth.isGestor();

    if (this.isGestor) {
      this.carregarResumo();
      this.carregarSetup();
    }

    setTimeout(() => this.tourService.verificarEDisparar('tour-home'), 500);
  }

  get onlinePercent(): number {
    if (!this.resumo || this.resumo.totalColaboradores === 0) return 0;
    return Math.round((this.resumo.totalOnline / this.resumo.totalColaboradores) * 100);
  }

  iniciarTour(): void {
    this.tourService.iniciar();
  }

  navegarParaStatus(status: string): void {
    this.router.navigate(['/pessoas'], {
      queryParams: { todos: 'true', status }
    });
  }

  abrirManual(): void {
    window.open('https://docs.imanagerportal.com/?secao=conhecendo-o-portal', '_blank');
  }

  iniciarTourManual(): void {
    this.tourFlagService.zerarFlag('tour_home_concluido').subscribe({
      next: () => this.tourService.iniciarTour('tour-home'),
      error: () => this.tourService.iniciarTour('tour-home'),
    });
  }

  private formatarData(data: Date): string {
    const str = data.toLocaleDateString('pt-BR', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  onDispensarSetup(): void {
    this.tourFlagService.marcarFlag('setup_dispensado', true).subscribe({
      next: () => this.mostrarSetup = false,
      error: () => this.mostrarSetup = false
    });
  }

  private carregarSetup(): void {
    this.onboardingApi.obterStatus().subscribe({
      next: (status) => {
        this.setupStatus = status;
        this.mostrarSetup = !status.completo && !status.dispensado;
      }
    });
  }

  private carregarResumo(): void {
    this.homeApi.obterResumo().subscribe({
      next: (res) => {
        this.resumo = res;
        this.carregando = false;
      },
      error: () => {
        this.carregando = false;
      }
    });
  }
}
